export class SubmitRequestExtensionModel {
    evaluationSk: string;
    reviewDate: Date;
    extensionDays: string;
    reason: string;
    otherReason: string;
    status: number;
    actionType: number;
    extensionDaysApproved: number;
    newDueByDate: Date;
    reasonForRejection: number;
    otherReasonForRejection: string;
    isApproved: boolean;
    evalutionName: string;
    dueDate: string;
    asstmtRejectionReasonOther: string;
    asstmtRejectionReason: number;
    asstmtReviewDate: Date
    asstmtReviewBy: string
    asstmtReviewApproved: boolean;
    nycId: string
    constructor(data: any) {
        this.evaluationSk = data?.evaluationSk;
        this.reviewDate = data?.reviewDate;
        this.extensionDays = data?.extensionDays;
        this.reason = data?.reason?.id;
        this.otherReason = data?.otherReason;
        this.status = data?.status === 8 ? 8 : data?.status === 7 ? 7 : 5;
        this.extensionDaysApproved = data?.extensionDaysApproved;
        this.newDueByDate = data?.newDueByDate;
        this.reasonForRejection = data?.reasonForRejection?.id;
        this.otherReasonForRejection = data?.otherReasonForRejection;
        this.isApproved = data?.isApproved;
        this.evalutionName = data?.evalutionName;
        this.dueDate = data?.dueDate
        this.asstmtRejectionReasonOther = data?.asstmtRejectionReasonOther;
        this.asstmtRejectionReason = data?.asstmtRejectionReason?.id;
        this.asstmtReviewDate = data?.asstmtReviewDate;
        this.asstmtReviewBy = data?.asstmtReviewBy;
        this.asstmtReviewApproved = data?.asstmtReviewApproved;
        this.nycId = data?.nycId;

    }

    get id(): string {
        return this.evaluationSk
    }
}